import React, { useState } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

const VaanOurProjectsCard = ({
  project,
  index,
  animationClass,
  isVisible,
  cardRefs,
  onVisitSite,
}) => {
  // Check if isbackground field has a color value (not empty)
  const hasSpecialBackground =
    project.isbackground && project.isbackground.trim() !== "";

  // Check if it's a billing software category
  const isBillingSoftware = project.category?.toLowerCase().includes("billing");

  // State for popup visibility
  const [showPopup, setShowPopup] = useState(false);

  const handleButtonClick = () => {
    if (isBillingSoftware) {
      setShowPopup(true);
    } else {
      onVisitSite(project.link);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <div className="vaanourproject-col col-12 col-md-6 col-lg-4">
        <div
          ref={(el) => (cardRefs.current[index] = el)}
          data-index={index}
          className={`vaanourproject-card ${animationClass} ${
            isVisible ? "vaanourproject-visible" : ""
          }`}
        >
          {/* Project Image */}
          <div
            className={`vaanourproject-image-wrapper ${
              hasSpecialBackground ? "vaanourproject-special-bg" : ""
            }`}
            style={
              hasSpecialBackground
                ? { backgroundColor: project.isbackground }
                : {}
            }
          >
            <img
              src={`https://api.dremerz.net/uploads/${project.image}`}
              alt={project.title}
              className="vaanourproject-image"
              onError={(e) => {
                e.target.src =
                  "https://via.placeholder.com/400x300?text=Project+Image";
              }}
            />
          </div>

          {/* Project Content */}
          <div className="vaanourproject-content">
            <div className="vaanourproject-badges">
              {/* Category Badge */}
              <div>
                <span className="vaanourproject-category-badge">
                  {project.category}
                </span>
              </div>

              {/* Location Badge with Icon */}
              {/* <div className="vaanourproject-location-badge">
                <FaMapMarkerAlt size={12} />
                <span>{project.location}</span>
              </div> */}
            </div>

            {/* Title - Fixed to always display */}
            <h3 className="vaanourproject-card-title">
              {project.title || "Untitled Project"}
            </h3>

            {/* Description */}
            <p className="vaanourproject-description">{project.description}</p>

            {/* Visit Site / Read More Button */}
            <button
              onClick={handleButtonClick}
              className={`vaanourproject-visit-btn ${
                isBillingSoftware ? "vaanourproject-readmore-btn" : ""
              }`}
            >
              <span>{isBillingSoftware ? "Read More" : "Visit Site"}</span>
              {!isBillingSoftware && (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Security Popup for Billing Software */}
      {showPopup && (
        <div className="vaanourproject-popup-overlay" onClick={closePopup}>
          <div
            className="vaanourproject-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="vaanourproject-popup-header">
              <h3 className="vaanourproject-popup-title">Security Notice</h3>
              <button
                className="vaanourproject-popup-close"
                onClick={closePopup}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            <div className="vaanourproject-popup-body">
              <div className="vaanourproject-popup-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>

              <h4 className="vaanourproject-popup-subtitle">
                Billing Software Security Protocol
              </h4>

              <p className="vaanourproject-popup-message">
                For security reasons and to protect sensitive financial data,
                direct access to billing software projects is restricted. These
                applications contain proprietary financial algorithms, secure
                payment processing systems, and confidential client billing
                information.
              </p>
            </div>

            <div className="vaanourproject-popup-footer">
              <button
                className="vaanourproject-popup-understand-btn"
                onClick={closePopup}
              >
                I Understand
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VaanOurProjectsCard;
